// extracted by mini-css-extract-plugin
module.exports = {"tagWrapper":"tag-wrapper_tagWrapper__TvF9Q","tagName":"tag-wrapper_tagName__LqHzf","tagWrapperLight":"tag-wrapper_tagWrapperLight__jChLd"};